module.exports = __webpack_public_path__ + "img/8_h_uk.dbc6e2c4.svg";